(function () {
  'use strict';

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function initTabs(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-zae-aj-tabs]').forEach(function (tabs) {
      if (tabs.dataset.zaeReady === 'true') return;
      tabs.dataset.zaeReady = 'true';

      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-zae-aj-tab]'));
      var card = tabs.closest('.zae-aj-info-card');
      if (!card) return;
      var panels = Array.prototype.slice.call(card.querySelectorAll('[data-zae-aj-panel]'));

      function activate(button) {
        var target = button.getAttribute('aria-controls');
        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          var sign = item.querySelector('.zae-aj-tab-sign');
          if (sign) sign.textContent = active ? '−' : '+';
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.id !== target;
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activate(button);
        });
      });
    });
  }

  function initGalleryButtons(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-zae-aj-zoom]').forEach(function (button) {
      if (button.dataset.zaeReady === 'true') return;
      button.dataset.zaeReady = 'true';
      button.addEventListener('click', function () {
        var gallery = button.closest('[data-image-gallery]');
        if (!gallery) return;
        var current = gallery.querySelector('.productView-nav .slick-current [data-fancybox]') ||
          gallery.querySelector('.productView-nav [data-fancybox]');
        if (current) current.click();
      });
    });

    root.querySelectorAll('[data-zae-aj-video]').forEach(function (button) {
      if (button.dataset.zaeReady === 'true') return;
      button.dataset.zaeReady = 'true';
      button.addEventListener('click', function () {
        var mediaId = button.getAttribute('data-zae-aj-video');
        var gallery = button.closest('[data-image-gallery]');
        if (!gallery || !mediaId) return;
        var thumb = gallery.querySelector('.productView-thumbnail[data-media-id="' + mediaId + '"]');
        if (thumb) {
          var control = thumb.querySelector('[role="button"]') || thumb;
          control.click();
          window.setTimeout(function () {
            var video = gallery.querySelector('.productView-nav .slick-current video');
            if (video && typeof video.play === 'function') {
              video.play().catch(function () {});
            }
          }, 250);
        }
      });
    });
  }

  function initStickyQuantity(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-zae-aj-sticky-quantity]').forEach(function (quantity) {
      if (quantity.dataset.zaeReady === 'true') return;
      quantity.dataset.zaeReady = 'true';
      var input = quantity.querySelector('input[name="quantity"]');
      if (!input) return;

      quantity.addEventListener('click', function (event) {
        var button = event.target.closest('[data-zae-qty-change]');
        if (!button) return;
        event.preventDefault();
        var direction = button.getAttribute('data-zae-qty-change');
        var current = parseInt(input.value, 10) || 1;
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10);
        var next = direction === 'plus' ? current + 1 : current - 1;
        if (next < min) next = min;
        if (!Number.isNaN(max) && next > max) next = max;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function syncStickyProductState() {
    var mainForm = document.querySelector('.productView-form form[data-type="add-to-cart-form"]');
    var stickyForm = document.querySelector('.productView-stickyCart form[data-type="add-to-cart-form"]');
    if (!mainForm || !stickyForm) return;

    var mainVariant = mainForm.querySelector('input[name="id"]');
    var stickyVariant = stickyForm.querySelector('input[name="id"]');
    if (mainVariant && stickyVariant && mainVariant.value) {
      stickyVariant.value = mainVariant.value;
    }

    var mainQuantity = mainForm.querySelector('input[name="quantity"]');
    var stickyQuantity = stickyForm.querySelector('.zae-aj-sticky-qty-input');
    if (mainQuantity && stickyQuantity) {
      var inventoryMax = mainQuantity.getAttribute('data-inventory-quantity') || mainQuantity.getAttribute('max');
      if (inventoryMax) {
        stickyQuantity.setAttribute('max', inventoryMax);
      } else {
        stickyQuantity.removeAttribute('max');
      }
      stickyQuantity.disabled = mainQuantity.disabled;
      stickyForm.querySelectorAll('[data-zae-qty-change]').forEach(function (button) {
        button.disabled = mainQuantity.disabled;
      });
    }

    var mainButton = mainForm.querySelector('[data-btn-addToCart]');
    var stickyButton = stickyForm.querySelector('[data-btn-addToCart]');
    if (mainButton && stickyButton) {
      stickyButton.disabled = mainButton.disabled;
      var label = mainButton.textContent.replace(/\s+/g, ' ').trim();
      if (label) stickyButton.textContent = label;
    }
  }

  function setMobileThumbnailCount() {
    if (!isMobile() || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;
    window.jQuery('.halo-productView .productView-for.slick-initialized').each(function () {
      var slider = window.jQuery(this);
      try {
        slider.slick('slickSetOption', 'slidesToShow', 4, true);
        slider.slick('slickSetOption', 'slidesToScroll', 1, true);
      } catch (error) {
        // Theme may still be initializing the gallery; the next scheduled run retries it.
      }
    });
  }

  function init(scope) {
    initTabs(scope);
    initGalleryButtons(scope);
    initStickyQuantity(scope);
    syncStickyProductState();
    setMobileThumbnailCount();
  }

  function boot() {
    init(document);
    window.setTimeout(function () { init(document); }, 350);
    window.setTimeout(function () { init(document); }, 1100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('.halo-productOptions') || event.target.matches('input[name="id"]')) {
      window.setTimeout(syncStickyProductState, 40);
      window.setTimeout(syncStickyProductState, 250);
    }
  });

  window.addEventListener('resize', function () {
    window.setTimeout(setMobileThumbnailCount, 100);
  });
})();
